import request from '@/utils/request'

export function points () {
  return request({
    url: '/points',
    method: 'post'
  })
}

export function getYears () {
  return request({
    url: '/query/years',
    method: 'post'
  })
}

export function getProvinces (params) {
  return request({
    url: '/query/provinces',
    method: 'post',
    data: params
  })
}

export function getCities (params) {
  return request({
    url: '/query/cities',
    method: 'post',
    data: params
  })
}

export function getDepartments (params) {
  return request({
    url: '/query/departments',
    method: 'post',
    data: params
  })
}

export function getFilters (params) {
  return request({
    url: '/query/filters',
    method: 'post',
    data: params
  })
}

export function getEntries (params) {
  return request({
    url: '/query/search',
    method: 'post',
    data: params
  })
}

export function getEntry (params) {
  return request({
    url: `/query/entry/${params}`,
    method: 'get'
  })
}

export function parseParams (params) {
  return request({
    url: '/query/parseParams',
    method: 'get',
    params
  })
}



// WEBPACK FOOTER //
// ./src/api/search.js